export default "__VITE_ASSET__hvAVYLo9__"